export default function Schedule({ copy }) {
  return (
    <section id="schedule" className="schedule section-shell">
      <div className="section-heading centered">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
      </div>
      <div className="schedule-grid">
        {copy.items.map((item, index) => (
          <article className="schedule-card" key={item.title}>
            <span className="schedule-number">0{index + 1}</span>
            <p className="schedule-time">{item.time}</p>
            <h3>{item.title}</h3>
            <p>{item.copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}